import api from './api';

export interface BankTransaction {
  id: string;
  userId: string;
  accountName: string;
  transactionDate: string;
  description: string;
  amount: number;
  balance?: number;
  reference?: string;
  category?: string;
  reconciled: boolean;
  invoiceId?: string;
  paymentId?: string;
  expenseId?: string;
  createdAt: string;
  // Populated when reconciled
  invoiceNumber?: string;
  invoiceTotal?: number;
  invoiceCurrency?: string;
  paymentAmount?: number;
  paymentCurrency?: string;
  expenseDescription?: string;
  expenseAmount?: number;
  expenseCurrency?: string;
}

export interface ReconciliationData {
  expenses: Array<{
    id: string;
    description: string;
    amount: number;
    expenseDate: string;
    currency: string;
    vendor?: string;
  }>;
  payments: Array<{
    id: string;
    amount: number;
    paymentDate: string;
    currency: string;
    invoiceId?: string;
  }>;
  invoices: Array<{
    id: string;
    invoiceNumber: string;
    total: number;
    issueDate: string;
    currency: string;
    clientId: string;
  }>;
  openingBalance?: {
    amount: number;
    currency: string;
    reconciled: boolean;
  } | null;
}

export interface ReconcileTransactionData {
  invoiceId?: string;
  paymentId?: string;
  expenseId?: string;
  category?: string;
  isOpeningBalance?: boolean;
  createAdhocPayment?: boolean;
  adhocPaymentDescription?: string;
  adhocPaymentReference?: string;
}

export const bankApi = {
  getTransactions: async (reconciled?: boolean): Promise<BankTransaction[]> => {
    const params = new URLSearchParams();
    if (reconciled !== undefined) {
      params.append('reconciled', reconciled.toString());
    }
    const queryString = params.toString();
    const url = `/bank/transactions${queryString ? `?${queryString}` : ''}`;
    const response = await api.get(url);
    return response.data.data;
  },

  getTransactionById: async (id: string): Promise<BankTransaction> => {
    const response = await api.get(`/bank/transactions/${id}`);
    return response.data.data;
  },

  uploadStatement: async (file: File, accountName: string): Promise<{ count: number }> => {
    const formData = new FormData();
    formData.append('statement', file);
    formData.append('accountName', accountName);

    const response = await api.post('/bank/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.data;
  },

  reconcileTransaction: async (transactionId: string, data: ReconcileTransactionData): Promise<BankTransaction> => {
    const response = await api.put(`/bank/transactions/${transactionId}/reconcile`, data);
    return response.data.data;
  },

  unreconcileTransaction: async (transactionId: string): Promise<BankTransaction> => {
    const response = await api.put(`/bank/transactions/${transactionId}/unreconcile`);
    return response.data.data;
  },

  getReconciliationData: async (): Promise<ReconciliationData> => {
    const response = await api.get('/bank/reconciliation-data');
    return response.data.data;
  },
};



